import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SchoolselectorComponent } from "./schoolselector/schoolselector.component";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { RadioButtonModule } from "primeng/radiobutton";
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";

import { AppSharedModule } from "../../shared/app-shared.module";
import { SchoolselectorService } from "./schoolselectorservice.service";
import { SchoolSelectTesterComponent } from "./school-select-tester/school-select-tester.component";

@NgModule({
	declarations: [SchoolselectorComponent, SchoolSelectTesterComponent],
	imports: [
		CommonModule,
		RadioButtonModule,
		FormsModule,
		AppSharedModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		TableModule,
		RouterModule,
		DropdownModule,
	],
	exports: [SchoolselectorComponent, SchoolSelectTesterComponent],
	providers: [SchoolselectorService],
})
export class SchoolselectorModule {}
